import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, map, switchMap } from 'rxjs/operators';
import { from, of } from 'rxjs';

import { labelActions } from './protocol-labels.actions';

import { TelespotLabelService } from '../../services';

@Injectable()
export class TelespotLabelEffects {
  constructor(private actions$: Actions, private service: TelespotLabelService) {}

  findByUuid = createEffect(() =>
    this.actions$.pipe(
      ofType(labelActions.fetchLabelsByUUID),
      switchMap(({ uuids }) =>
        from(this.service.fetchByUuid(uuids)).pipe(
          map((labels) => labelActions.fetchLabelsByUUIDSuccess({ labels })),
          catchError((error) => of(labelActions.fetchLabelsByUUIDFailure({ error: error.message })))
        )
      )
    )
  );
}
